export default {
  namespaced: true,
  state: {
    isVisible: false,
    dispatch: {
      userData: '',
      date: ''
    },
    documentsToUpload: []
  },
  getters: {
    isVisible: state => state.isVisible,
    dispatchData: state => state.dispatch,
    documentsToUpload: state => state.documentsToUpload
  },
  mutations: {
    toggleModal (state) {
      state.isVisible = !state.isVisible
    },
    setDispatchData (state, payload) {
      Object.assign(state.dispatch, payload)
    },
    setDocumentsToUpload (state, payload) {
      state.documentsToUpload = payload
    }
  },
  actions: {
  }
}
